<template>
  <div>
    <div class="columns">
      <div class="column is-8">
        <div class="card">
          <header class="header-card">
            <p>{{ $t('ajoutEditContrat.contrat.title')}}</p>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-4">
                <b-field :label="$t('ajoutEditContrat.contrat.dateSignature')">
                  <b-datepicker
                    show-week-number
                    @input="setDateDebutSignature"
                    v-model="contrat.dateSignature"
                    icon="calendar-today"
                    nearby-selectable-month-days
                    editable>
                  </b-datepicker>
                </b-field>
              </div>
              <div class="column is-4">
                <parametre-autocomplete
                  :label="$t('ajoutEditContrat.contrat.signataire')"
                  v-model="contrat.signataireId"
                  :target="constantes.PARAMETRES_KEYS.contratSignataire"
                  expanded
                />
              </div>
            </div>
            <div class="columns is-multiline">
              <div class="column is-6">
                <div class="columns is-multiline">
                <b-field :label="$t('ajoutEditContrat.contrat.dateDebut')"
                    class="obligatoire column is-8">
                  <b-datepicker
                      show-week-number
                      @input="setDateSignature"
                      :value="contrat.dateDebutSignature"
                      icon="calendar-today"
                      nearby-selectable-month-days
                      editable>
                    </b-datepicker>
                </b-field>
                  <b-field :label="$t('ajoutEditContrat.contrat.nbAn')" class="column is-4">
                  <b-input
                      type="number"
                      v-model="nbAn"
                      @input="setDateFinSignature">
                    </b-input>
                  </b-field>
                </div>
              </div>
            <div class="column is-6">
                <div class="columns is-multiline">
                  <b-field :label="$t('ajoutEditContrat.contrat.dateFin')"
                    class="obligatoire column is-8">
                    <b-datepicker
                      show-week-number
                      @input="setDate"
                      v-model="contrat.dateFinSignature"
                      icon="calendar-today"
                      nearby-selectable-month-days
                      editable>
                    </b-datepicker>
                  </b-field>
                  <div class="column is-4">
                    <b-field label="Durée contrat">
                      <b-input :disabled="true" :value="getDifferenceBetweenDate"></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <b-field :label="$t('ajoutEditContrat.contrat.datePreavis')" class="obligatoire">
                  <b-datepicker
                    show-week-number
                    v-model="contrat.datePreavis"
                    icon="calendar-today"
                    nearby-selectable-month-days
                    editable>
                  </b-datepicker>
                </b-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="card height-100">
          <header class="header-card">
            <p>{{ $t('ajoutEditContrat.contrat.titleResponsableDemarcheur') }}</p>
          </header>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-12">
                <b-field :label="$t('ajoutEditContrat.contrat.demarcheur')">
                  <b-autocomplete
                    @input="getAsyncDemarcheurData"
                    @select="setDemarcheur"
                    :value="searchDemarcheur"
                    :data="demarcheursFilter"
                    :loading="isFetchingDemarcheur"
                    field="nomCommercial"
                    icon="magnify">
                    <template slot="header">
                      <a @click="checkPermissions(permDemarcheur.maj)
                        ? isComponentAjoutDemarcheur = true : showPopUp()">
                        <a class="lien"
                        :class="{ 'text-access-no-permission' :
                          !checkPermissions(permDemarcheur.maj)}">
                          <span> {{ $t('ajoutEditContrat.actions.addDemarcheur') }}</span>
                        </a>
                      </a>
                    </template>
                    <template slot-scope="props">
                      {{ props.option.nomCommercialAvecVille }}
                    </template>
                    <template slot="empty">
                      {{$t(`general.autocomplete.${!isFetchingDemarcheur ? 'noRslt' : 'search'}`)}}
                    </template>
                  </b-autocomplete>
                </b-field>
              </div>
              <div class="column is-12">
                <b-field :label="$t('ajoutEditContrat.contrat.commission')">
                  <input-currency v-model="contrat.commission" isNumber="true" symbole=' €'>
                  </input-currency>
                </b-field>
              </div>
              <div class="column is-12">
                <user-selector
                  v-model="contrat.responsableBailId"
                  :label="$t('ajoutEditContrat.contrat.responsableBail')"
                  :critere="(u) => u.responsableBail"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="isComponentAjoutDemarcheur"
      has-modal-card
      class="modal"
      @close="nomDemarcheur=''">
      <creation-demarcheur @creationDone ="setDemarcheur"
          :nomDemarcheur="searchDemarcheur"></creation-demarcheur>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { getAllByTradeName } from '@/api/tiers';
import { TIERS_SOUS_TYPE_DEMARCHEUR, TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import messageErreur from '@/services/general/messageErreur';
import getDifferenceBetweenDateLibelleYearsMonthsDays from '@/services/baux/contrat/getDifferenceBetweenDateLibelleYearsMonthsDays';
import getDifferenceBetweenDateYearsMonthsDays from '@/services/general/getDifferenceBetweenDateYearsMonthsDays';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import inputCurrency from '@/components/general/inputCurrency';
import { DEMARCHEUR } from '@/configuration/baux/permissionsBauxConf';
import creationDemarcheur from '@/components/baux/contrat/componentEdition/p_creationDemarcheur';
import userSelector from '@/components/commun/user/userSelector';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'BauxContratEditContrat',
  props: {
    contrat: {
      required: true,
      type: Object,
    },
    echeancier: {
      required: true,
      type: Object,
    },
  },
  components: {
    ParametreAutocomplete,
    inputCurrency,
    creationDemarcheur,
    userSelector,
  },
  data() {
    return {
      nbAn: null,
      searchDemarcheur: '',
      demarcheursFilter: [],
      isFetchingDemarcheur: false,
      isComponentAjoutDemarcheur: false,
      permDemarcheur: DEMARCHEUR,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getDifferenceBetweenDate() {
      return getDifferenceBetweenDateLibelleYearsMonthsDays(
        this.contrat.dateDebutSignature,
        this.contrat.dateFinSignature,
        this.$i18n,
      );
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    setDateDebutSignature() {
      if (this.contrat.dateDebutSignature) return;
      this.contrat.dateDebutSignature = this.contrat.dateSignature;
      this.setDateFinSignature();
    },
    setDateFinSignature() {
      if (!this.contrat.dateDebutSignature || !this.nbAn) return;
      this.contrat.dateFinSignature = cloneDeep((
        moment(this.contrat.dateDebutSignature).add(this.nbAn, 'y').add(-1, 'd')
      )).toDate();
      this.setDate();
    },
    setDateSignature(dateDebut) {
      if (!this.contrat.dateSignature) {
        this.contrat.dateSignature = dateDebut;
      }
      if (!this.contrat.dateFinSignature) this.setDateFinSignature();
      this.contrat.dateDebutSignature = dateDebut;
      this.setDateFinSignature();
    },
    setDate() {
      this.setEcheancierDate();
      this.setDatePreavis();
    },
    setDatePreavis() {
      const difference = getDifferenceBetweenDateYearsMonthsDays(
        this.contrat.dateDebutSignature,
        this.contrat.dateFinSignature,
      );
      if (!difference) return;
      if (difference.months > 3 || difference.years >= 1) {
        const dateFin = cloneDeep(this.contrat.dateFinSignature);
        this.contrat.datePreavis = moment(moment(dateFin).subtract(3, 'month')).toDate();
      } else {
        this.contrat.datePreavis = cloneDeep(this.contrat.dateFinSignature);
      }
    },
    setEcheancierDate() {
      if (!this.contrat.dateDebutEcheance && this.contrat.dateDebutSignature) {
        this.contrat.dateDebutEcheance = this.contrat.dateDebutSignature;
        this.echeancier.dateDebut = this.contrat.dateDebutSignature;
      }
      if (!this.contrat.dateFinEcheance && this.contrat.dateFinSignature) {
        this.echeancier.dateFin = this.contrat.dateFinSignature;
        this.contrat.dateFinEcheance = this.contrat.dateFinSignature;
      }
    },
    getAsyncDemarcheurData: debounce(async function loadData(text) {
      if (text === this.searchDemarcheur) return;
      this.isFetchingDemarcheur = true;
      this.searchDemarcheur = text;
      this.contrat.fournisseurDemarcheurId = null;
      try {
        const tiers = (await getAllByTradeName(
          text, this.societeActiveId,
          TIERS_TYPE_FOURNISSEUR, [TIERS_SOUS_TYPE_DEMARCHEUR],
        )).data.result.items;
        tiers.forEach(this.formatTiers);
        this.demarcheursFilter = tiers;
        this.isFetchingDemarcheur = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingDemarcheur = false;
        throw (e);
      }
    }, 500),
    setDemarcheur(item) {
      if (!item) return;
      this.searchDemarcheur = item.nomCommercial;
      this.contrat.fournisseurDemarcheurId = item.id;
    },
    formatTiers(tiers) {
      const wordsList = [
        tiers.code, tiers.nomCommercial,
        adressFullStringGetter(tiers.adressePostale, false),
        tiers.compteComptable];
      tiers.nomCommercialAvecVille = wordsList.filter(w => !!w).join(' - ');
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.contrat.fournisseurDemarcheur) {
        this.formatTiers(this.contrat.fournisseurDemarcheur);
        this.setDemarcheur(this.contrat.fournisseurDemarcheur);
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
